"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStorageByKey = exports.setUrls = exports.clearTokens = exports.getTokens = exports.storeTokens = void 0;
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
var store_1 = __importDefault(require("store"));
var constant_1 = require("../utils/constant");
var storeTokens = function (tokens) {
    // @TODO on the future ask encryption key to the server to cipher key and token
    store_1.default.set(constant_1.MKP_TOKEN_KEY, tokens === null || tokens === void 0 ? void 0 : tokens.marketplaceToken);
    store_1.default.set(constant_1.SAAS_TOKEN_KEY, tokens === null || tokens === void 0 ? void 0 : tokens.saasToken);
    return tokens;
};
exports.storeTokens = storeTokens;
var getTokens = function () { return ({
    marketplaceToken: store_1.default.get(constant_1.MKP_TOKEN_KEY),
    saasToken: store_1.default.get(constant_1.SAAS_TOKEN_KEY),
}); };
exports.getTokens = getTokens;
var clearTokens = function () {
    store_1.default.remove(constant_1.MKP_TOKEN_KEY);
    store_1.default.remove(constant_1.SAAS_TOKEN_KEY);
    return exports.getTokens();
};
exports.clearTokens = clearTokens;
var setUrls = function (networkOptions) {
    return Object.entries(networkOptions !== null && networkOptions !== void 0 ? networkOptions : [])
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return store_1.default.set(key, value);
    });
};
exports.setUrls = setUrls;
var getStorageByKey = function (key) {
    return store_1.default.get(key);
};
exports.getStorageByKey = getStorageByKey;
